import styled from 'styled-components'

import type { BlogTag as BlogTagType } from '@/types/blog'

export const BlogTag = ({ name, tagColor }: BlogTagType) => {
  return <Tag color={tagColor}>#{name}</Tag>
}

const Tag = styled.span<{ color: string }>`
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0;
  color: #ffffff;
  background-color: ${({ color }) => color};
  padding: 0 18px 0 16px;
  border-radius: 14px;

  @media screen and (max-width: 1047px) {
    font-size: 13px;
    line-height: 23px;
  }
`
